import callApi from "helpers/callApi";

const updateUserJobPost = async (id, data) => {
  return await callApi(`/user_job_post_update/${id}`, data, "PUT");
};
export { updateUserJobPost };
